// removed by extract-text-webpack-plugin
module.exports = {"loadingSpin":"loadingSpin___Kl2NE","internalItem":"internalItem___1C_c5","internal":"internal___3sjYx","commentItem":"commentItem___3JeQv","commentContent":"commentContent___36Iuz","meta":"meta___1CjC3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Comments/CommentList.module.scss
// module id = 669
// module chunks = 0